<template>
  <div class="messagelist_container">
    <div class="navbar">
      <navbar :titlename="titlename"></navbar>
    </div>

    <div style="padding-top:50px;">
      <div
        v-for="(item,index) in messagelist"
        :key="index"
        class="messagelist"
        @click="gomsg"
        :data-id="item.from_uid"
        :data-chatname="item.name"
        data-ceshi="woshicewsshi"
      >
        <div class="message-tx">
          <img :src="item.avatar_url" />
        </div>
        <div class="message-xx">
          <span class="message-name">{{item.name}}</span>
          <div class="message-text">{{item.msg}}</div>
        </div>
        <div class="message-time">
          <div class="message-times">{{item.date}}</div>
          <div class="message-count" v-if="item.unread">
            <div class="cu-tag round bg-red message-counts">{{item.unread}}</div>
          </div>
          <div class="message-count" v-else></div>
        </div>
      </div>
      <div class="nofollowbox" v-if="messagelist.length == 0">
        <div class="nofollowpic">
          <img :src="circleIconWu" />
        </div>
        <div class="nosearchtext">暂无消息</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getmessageList } from "../../api/api";
import navbar from "../public/navbar.vue";
export default {
  name: "messagelist",
  components: { navbar },
  data() {
    return {
      titlename: "消息列表",
      messagelist: [],
      circleIconWu:require('../../assets/images/circle_icon_wu.png'),
    };
  },
  created() {
    document.title='消息列表';
    getmessageList().then(res => {
      if (res.data.code == 200) {
        this.messagelist = res.data.data.list;
      } else {
        console.log("请求数据失败");
      }
    });
    /*     this.messagelist =   [
      {
          id: "5",
          from_uid: "5",
          name: "渡",
          avatar_url: "https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLzW1k062udhmZBoV6ZgQoduEwA0BO15zUIH9Yzz7oBUKPw78ibjEfOcibGvQLFGjHzt7u4gjkqWoIQ/0",
          msg: "哈哈哈哈哈哈",
          date: "05/21",
          unread: "7"
        },
        {
          id: "10",
          from_uid: "7",
          name: "胖子",
          avatar_url:
            "https://wx.qlogo.cn/mmopen/vi_32/pSRTJsVK3V9IUNic4Kq9IEDmxIX8B8guhskicVr8gIXLTVuhbiac2cp6vLkzNhuicfZoL5W53Hibq8DN8eicr3ibB103g/132",
          msg: "测试数据啊啊啊10",
          date: "05/14",
          unread: "2"
        },
         {
                "id": "5",
                "from_uid": "1",
                "name": "你好啊",
                "avatar_url": 'https://api.xianpipa.com/uploads/avatars/avatar_156591813897994898.png',
                "msg": "测试数据啊啊啊5",
                "date": "05/13",
                "unread": 0
            },
             {
          id: "19",
          from_uid: "3",
          name: "庄萍萍萍",
          avatar_url: "https://api.xianpipa.com/uploads/avatars/avatar_156591792250549797.png",
          msg: "哈哈哈哈哈哈",
          date: "05/21",
          unread: "7"
        },
        {
          id: "10",
          from_uid: "4",
          name: "啊啊啊啊啊啊啊啊啊啊啊",
          avatar_url:
            "https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKIxTSS3SDJDGK7PVQvO7GRb8VHoTDicbG8uicHHqh92PicHcPbksSpibKw7Opqag8rGKLcqRVUVtU43A/132",
          msg: "测试数据啊啊啊10",
          date: "05/14",
          unread: "2"
        },
         {
                "id": "5",
                "from_uid": "1",
                "name": "你好啊",
                "avatar_url": 'https://api.xianpipa.com/uploads/avatars/avatar_156591813897994898.png',
                "msg": "测试数据啊啊啊5",
                "date": "05/13",
                "unread": 0
            },
             {
          id: "19",
          from_uid: "3",
          name: "庄萍萍萍",
          avatar_url: "https://api.xianpipa.com/uploads/avatars/avatar_156591792250549797.png",
          msg: "哈哈哈哈哈哈",
          date: "05/21",
          unread: "7"
        },
        {
          id: "10",
          from_uid: "4",
          name: "啊啊啊啊啊啊啊啊啊啊啊",
          avatar_url:
            "https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKIxTSS3SDJDGK7PVQvO7GRb8VHoTDicbG8uicHHqh92PicHcPbksSpibKw7Opqag8rGKLcqRVUVtU43A/132",
          msg: "测试数据啊啊啊10",
          date: "05/14",
          unread: "2"
        },
         {
                "id": "5",
                "from_uid": "1",
                "name": "你好啊",
                "avatar_url": 'https://api.xianpipa.com/uploads/avatars/avatar_156591813897994898.png',
                "msg": "测试数据啊啊啊5",
                "date": "05/13",
                "unread": 0
            },
             {
          id: "19",
          from_uid: "3",
          name: "庄萍萍萍",
          avatar_url: "https://api.xianpipa.com/uploads/avatars/avatar_156591792250549797.png",
          msg: "哈哈哈哈哈哈",
          date: "05/21",
          unread: "7"
        },
        {
          id: "10",
          from_uid: "4",
          name: "啊啊啊啊啊啊啊啊啊啊啊",
          avatar_url:
            "https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKIxTSS3SDJDGK7PVQvO7GRb8VHoTDicbG8uicHHqh92PicHcPbksSpibKw7Opqag8rGKLcqRVUVtU43A/132",
          msg: "测试数据啊啊啊10",
          date: "05/14",
          unread: "2"
        },
         {
                "id": "5",
                "from_uid": "1",
                "name": "你好啊",
                "avatar_url": 'https://api.xianpipa.com/uploads/avatars/avatar_156591813897994898.png',
                "msg": "测试数据啊啊啊5",
                "date": "05/13",
                "unread": 0
            },
             {
          id: "19",
          from_uid: "3",
          name: "庄萍萍萍",
          avatar_url: "https://api.xianpipa.com/uploads/avatars/avatar_156591792250549797.png",
          msg: "哈哈哈哈哈哈",
          date: "05/21",
          unread: "7"
        },
        {
          id: "10",
          from_uid: "4",
          name: "啊啊啊啊啊啊啊啊啊啊啊",
          avatar_url:
            "https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKIxTSS3SDJDGK7PVQvO7GRb8VHoTDicbG8uicHHqh92PicHcPbksSpibKw7Opqag8rGKLcqRVUVtU43A/132",
          msg: "测试数据啊啊啊10",
          date: "05/14",
          unread: "2"
        },
         {
                "id": "5",
                "from_uid": "1",
                "name": "你好啊",
                "avatar_url": 'https://api.xianpipa.com/uploads/avatars/avatar_156591813897994898.png',
                "msg": "测试数据啊啊啊5",
                "date": "05/13",
                "unread": 0
            },
             {
          id: "19",
          from_uid: "3",
          name: "庄萍萍萍",
          avatar_url: "https://api.xianpipa.com/uploads/avatars/avatar_156591792250549797.png",
          msg: "哈哈哈哈哈哈",
          date: "05/21",
          unread: "7"
        },
        {
          id: "10",
          from_uid: "4",
          name: "啊啊啊啊啊啊啊啊啊啊啊",
          avatar_url:
            "https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKIxTSS3SDJDGK7PVQvO7GRb8VHoTDicbG8uicHHqh92PicHcPbksSpibKw7Opqag8rGKLcqRVUVtU43A/132",
          msg: "测试数据啊啊啊10",
          date: "05/14",
          unread: "2"
        },
         {
                "id": "5",
                "from_uid": "1",
                "name": "你好啊",
                "avatar_url": 'https://api.xianpipa.com/uploads/avatars/avatar_156591813897994898.png',
                "msg": "测试数据啊啊啊5",
                "date": "05/13",
                "unread": 0
            },
    ] */
  },
  methods: {
    gomsg: function(e) {
      this.$router.push({
        name: "chat",
        query: {
          id: e.currentTarget.dataset.id,
          chatname: e.currentTarget.dataset.chatname
        }
      });
    }
  }
};
</script>

<style scoped>
.navbar {
  position: relative;
  z-index: 99;
}
/* pages/index/message/message-template/message-template.wxss */
.messagelist_container {
  height: 100%;
  background-color: #f8f8f8;
}
.messagelist {
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  margin: 0 auto;
  background: #fff;
  border-top: 0.02702702702702703rem solid #eee;
  padding-left: 3%;
  padding-right: 3%;
  padding-top: 0.8108108108108109rem;
  padding-bottom: 0.5405405405405406rem;
}
.messagelist .message-tx {
  flex: 2;
  width: 2.5945945945945947rem;
  height: 2.5945945945945947rem;
}
.messagelist .message-tx img {
  width: 100%;
  width: 2.5945945945945947rem;
  height: 2.5945945945945947rem;
  border-radius: 50%;
}
.messagelist .message-xx {
  flex: 8;
  width: 12.432432432432432rem;
  box-sizing: border-box;
  padding-left: 0.5405405405405406rem;
}
.messagelist .message-xx .message-name {
  font-size: 0.8108108108108109rem;
  font-weight: bold;
  padding-bottom: 0.4864864864864865rem;
  display: block;
}
.messagelist .message-xx .message-text {
  width: 12.432432432432432rem;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #999;
  font-size: 0.6486486486486487rem;
}
.messagelist .message-time {
  width: 4.054054054054054rem;
}
.messagelist .message-time .message-times {
  font-size: 0.5405405405405406rem;
  /*  padding-top: 0.35135135135135137rem; */
  padding-bottom: 0.2702702702702703rem;
  text-align: right;
  color: #aaa;
}
.messagelist .message-time .message-count {
  text-align: right;
}
.messagelist .message-time .message-count .message-counts {
  line-height: 0.5405405405405406rem;
  height: 1.0810810810810811rem;
}
.messagelist .message-time .message-count .cu-tag {
  height: 1.162162162162162rem;
}
.nofollowbox {
  padding-top: 2.7027027027027026rem;
  text-align: center;
}
.nofollowbox .nofollowpic {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
  margin: 0 auto;
}
.nofollowbox .nofollowpic img {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
}
.nofollowbox .nosearchtext {
  text-align: center;
  padding-top: 1.3513513513513513rem;
  font-size: 0.7567567567567568rem;
  color: #999;
}
.cu-tag {
  font-size: 0.5405405405405406rem;
  vertical-align: middle;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0rem 0.43243243243243246rem;
  /*      height: 1.2972972972972974rem; */
  font-family: Helvetica Neue, Helvetica, sans-serif;
  white-space: nowrap;
  background-color: red;
  color: white;
  border-radius: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/messagelist.vue